export default __webpack_public_path__ + "static/media/checked.88856083.svg";